import React, {useState} from 'react';
import {Text, FlatList} from 'react-native';
import {useNavigation} from '@react-navigation/core';
import {RHButton} from 'src/common-components/custom-ui-helpers';
import {Typography} from 'src/styles';
import {
  RenderAppointment,
  APPOINTMENTCARDTYPE,
} from 'src/modules/scheduling/components';
import {compose} from 'recompose';
import {withObservables} from '@nozbe/watermelondb/react';
import {withDatabase} from '@nozbe/watermelondb/react';
import withState from 'src/redux/wrapper';
import {of} from 'rxjs';
import DeleteSessionModal from 'src/modules/scheduling/components/delete-session-modal';
import moment from 'moment';
import NoResults from 'src/common-components/noResults';
import {useStyle} from 'src/providers/style';

interface Props {
  patient: any;
  appointments: [];
  role: any;
}

const Sessions = ({patient, appointments, role}: Props) => {
  const navigation = useNavigation();
  const styles = useStyle();

  const [showDelete, setShowDelete] = useState(false);

  const goToNewSession = () => {
    navigation.navigate('ScheduleAppointment', {
      patient: patient.id,
    });
  };

  const deleteCallback = (item: any) => {
    setShowDelete({appointment: item, date: moment(item.date).toDate()});
  };
  const deleteCancelled = () => {
    setShowDelete(false);
  };

  return (
    <>
      {appointments?.length === 0 ? (
        <NoResults
          iconName={'calendar-today'}
          secondaryMessage={'No sessions today'}
        />
      ) : (
        <>
          <Text style={[Typography.P1, styles.textColorSecondary]}>
            Next Session
          </Text>
          <FlatList
            data={appointments}
            keyExtractor={item => item.id}
            renderItem={({item}: any) => {
              return (
                <RenderAppointment
                  date={moment(item.date).toDate()}
                  appointment={item}
                  type={APPOINTMENTCARDTYPE.PATIENT_CARD}
                  canEdit={role?.appointmentEdit}
                  canDelete={role?.appointmentDelete}
                  deleteCallback={deleteCallback}
                />
              );
            }}
          />
          <DeleteSessionModal
            show={[showDelete, setShowDelete]}
            deleteCancelled={() => deleteCancelled()}
          />
        </>
      )}
      <RHButton
        style={[styles.marginVertical]}
        secondary
        onPress={goToNewSession}
        mode={'contained'}>
        SCHEDULE A SESSION
      </RHButton>
    </>
  );
};

export default compose(
  withDatabase,
  withState,
  withObservables(['authentication'], ({authentication, database}: any) => ({
    profile: authentication.userId
      ? database.get('users').findAndObserve(authentication.userId)
      : of(),
  })),
  withObservables([], ({profile}: any) => {
    return {
      role: profile.role,
    };
  }),
  withObservables(['patient'], ({patient}: any) => ({
    patient,
    appointments: patient.futureAppointments,
  })),
)(Sessions);
